import { api } from "../../../api/api";
import { appConfig } from "../../../config/runtime-config";

const host = appConfig.guruUrl;
const basePath = appConfig.apiBasePath;
const resource = "overview";
const url = `${host}/${basePath}/${resource}`;

/** @param {OverviewFilters} filters @returns {Promise<OverviewResponse>} */
export const get = (filters) =>
  api.get(url, { ...filters }).then((res) => res.data);

/** @param {string} versionId @returns {Promise<OverviewResponse>} */
export const getVersion = (versionId) =>
  api.get(`${url}/version/${versionId}`).then((res) => res.data);

/** @param {string} serviceName @returns {Promise<any[]>} */
export const getServiceEndpoints = (serviceName) =>
  api.get(`${url}/service/${serviceName}/endpoints`).then((res) => res.data);

/** @param {string} source @param {string} target @returns {Promise<any>} */
export const getEdgeContract = (source, target) =>
  api.get(`${url}/edge/${source}/${target}/contract`).then((res) => res.data);
